import { render, staticRenderFns } from "./PaymentReport.vue?vue&type=template&id=284fb6a2&scoped=true"
import script from "./PaymentReport.vue?vue&type=script&lang=js"
export * from "./PaymentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284fb6a2",
  null
  
)

export default component.exports